/**
 * Dawin Finishes — header docking and joining (handoff Round 6 §30–31).
 *
 * Once the header is pinned:
 *   - a full-width sticky toolbar touching its bottom edge docks:
 *     html.is-docked, the bar gets .is-docked-bar, and --frame-h is set to
 *     the bar's bottom edge so the page-colour frame runs down its sides;
 *   - the first rounded panel reaching the header (or the docked bar)
 *     joins it: html.is-joined, the panel gets .is-joined-panel.
 * The styles live in dawin-base.css ("Docking and joining").
 *
 * Adapted from the handoff's script, which scans main's direct children.
 * On this theme those are .shopify-section wrappers and never rounded, so
 * the panels are the same blocks the page-ground rules treat as panels.
 * The form step bar sits inside its column, narrower than the header, so
 * it never docks: it pins flush but keeps its own corners.
 *
 * Round 7 §33: joining also runs unpinned (a panel touching the header
 * at rest joins it), the hero never joins, and the product stage can join
 * even though its top corners are already square.
 *
 * One rAF per scroll; layout reads, then class toggles only.
 */
(function () {
  if (window.__dawinDock) return; // idempotent
  window.__dawinDock = true;

  var root = document.documentElement;
  var BARS = '[data-sticky-tool]';
  var PANELS = [
    '#main > .shopify-section > :is(section, nav, footer)',
    '#main > .shopify-section > .dawin-page > :is(section, nav)',
    '#main > .shopify-section > main.fm-page',
    '#main > .shopify-section:not([class*="shopify-section--dawin-"])'
  ].join(',');
  var TOUCH = 2; // px: the bar's top follows the header's published edge a frame late while it animates

  var ticking = false;

  function px(v) { return parseFloat(v) || 0; }

  function update() {
    ticking = false;
    var hdr = document.getElementById('dawinHeader');
    if (!hdr) return;
    var pinned = hdr.classList.contains('is-pinned');
    var hr = hdr.getBoundingClientRect();
    var gap = px(getComputedStyle(root).getPropertyValue('--band-gap')) || 12;

    var docked = null;
    document.querySelectorAll(BARS).forEach(function (b) {
      var r = b.getBoundingClientRect();
      var on = pinned && !docked && r.height > 0 &&
        Math.abs(r.top - hr.bottom) < TOUCH &&
        Math.abs(r.left - hr.left) < TOUCH && Math.abs(r.right - hr.right) < TOUCH;
      b.classList.toggle('is-docked-bar', on);
      if (on) docked = b;
    });
    root.classList.toggle('is-docked', !!docked);
    if (docked) root.style.setProperty('--frame-h', Math.round(docked.getBoundingClientRect().bottom) + 'px');
    else root.style.removeProperty('--frame-h');

    var joined = null;
    var edge = docked ? docked.getBoundingClientRect().bottom : hr.bottom;
    document.querySelectorAll(PANELS).forEach(function (el) {
      if (el.matches(BARS) || el.matches('.hx')) return;
      var on = false;
      if (!joined) {
        var wasJoined = el.classList.contains('is-joined-panel');
        // Only panels that already have a radius can join (a joined one
        // reads 0 while it is joined, so it keeps its place); the stage is
        // square on top by design.
        if (wasJoined || el.matches('.pd-stage') || px(getComputedStyle(el).borderTopLeftRadius) > 0) {
          var r = el.getBoundingClientRect();
          // Unpinned, only a panel actually touching the header joins.
          on = r.top <= edge + (pinned ? gap : TOUCH) && r.bottom > edge + gap;
        }
      }
      el.classList.toggle('is-joined-panel', on);
      if (on) joined = el;
    });
    root.classList.toggle('is-joined', !!joined);
  }

  function request() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(update);
  }

  addEventListener('scroll', request, { passive: true });
  addEventListener('resize', request);
  // The header animates 72 → 60px as it pins; the bar follows it a frame
  // behind, so re-check while that runs.
  var hdr = document.getElementById('dawinHeader');
  if (hdr && 'ResizeObserver' in window) new ResizeObserver(request).observe(hdr);
  if (hdr && 'MutationObserver' in window) {
    new MutationObserver(request).observe(hdr, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', request, { once: true });
  else request();
  document.addEventListener('shopify:section:load', request);
})();
